import { render, staticRenderFns } from "./ExampleDetail.vue?vue&type=template&id=66b98258&scoped=true"
import script from "./ExampleDetail.vue?vue&type=script&lang=js"
export * from "./ExampleDetail.vue?vue&type=script&lang=js"
import style0 from "./ExampleDetail.vue?vue&type=style&index=0&id=66b98258&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b98258",
  null
  
)

export default component.exports